function createPathPropType(isRequired) {
  /**
   * Custom prop validation for step path.
   * Path should start with a letter and contain any number of sections, separated by '.'
   * E.g. 'page1', 'page2.substep1', or 'main.users.access-control'.
   * @param {Object} props - Dictionary of props passed to the component.
   * @param {String} propName - Name of the prop.
   * @param {String} componentName - Name of the component.
   * @returns {Error} - Returns an Error object if the path is not valid, otherwise returns null.
   */
  return (props, propName, componentName) => {
    const prop = props[propName];

    // The prop `title` is marked as required in `Step`, but its value is `undefined`.
    if (prop == null && isRequired) {
      return new Error(`The prop ${propName} is marked as required in ${componentName}, but its value is ${prop}.`);
    }

    if (prop != null && !/^[A-Za-z][\w-]*(\.[\w-]+)*$/.test(props[propName])) {
      return new Error(`Invalid prop ${propName} supplied to ${componentName}. Validation failed.`);
    }

    return null;
  };
}

export const pathPropType = createPathPropType(false);
pathPropType.isRequired = createPathPropType(true);
